<script context="module"></script>

<script>import { onMount } from "svelte";
export let replaceNodes = undefined;
export let code;
let elementRef;
let scriptsInserted = [];
let scriptsRun = [];
onMount(() => {
    // TODO: Move this function to standalone one in '@builder.io/utils'
    if (!elementRef?.getElementsByTagName || typeof window === "undefined") {
        return;
    }
    const scripts = elementRef.getElementsByTagName("script");
    for (let i = 0; i < scripts.length; i++) {
        const script = scripts[i];
        if (script.src) {
            if (scriptsInserted.includes(script.src)) {
                continue;
            }
            scriptsInserted.push(script.src);
            const newScript = document.createElement("script");
            newScript.async = true;
            newScript.src = script.src;
            document.head.appendChild(newScript);
        }
        else if (!script.type ||
            [
                "text/javascript",
                "application/javascript",
                "application/ecmascript",
            ].includes(script.type)) {
            if (scriptsRun.includes(script.innerText)) {
                continue;
            }
            try {
                scriptsRun.push(script.innerText);
                new Function(script.innerText)();
            }
            catch (error) {
                console.warn("`CustomCode`: Error running script:", error);
            }
        }
    }
});
</script>

<div
  bind:this={elementRef}
  class={"builder-custom-code" + (replaceNodes ? " replace-nodes" : "")}
>
  {@html code}
</div>